import { useQuery } from '@tanstack/react-query';
import { gymApi } from '@/lib/api';

/**
 * Resolve a signed URL for a client photo. The signed URL is cached per
 * photo_path (valid for ~1h) to avoid re-signing on every render.
 */
export function useClientPhoto(photoPath?: string | null) {
  return useQuery({
    queryKey: ['clientPhoto', photoPath],
    queryFn: async () => {
      const res = await gymApi.getClientPhotoUrl(photoPath as string);
      return res.url;
    },
    enabled: !!photoPath,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}
